<template>
  <div>
    <div class="box-card">
      <div style="margin-bottom: 10px"><i class="card-line"></i>资产配置</div>

      <spread-table v-loading="loading" :tableHeight="tableHeight" :pageSize="pageSize" :currentPage="currentPage" :total="total" @sizeChange="sizeChange" @currentChange="currentChange" :tableColumn="drafrList" :tableData="spreadTable"></spread-table>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import SpreadTable from '@/components/SpreadTable'
import { findAssetAllocation } from "./exponentApi";
export default defineComponent({
  name: "asset-allocation",
  components: {
    SpreadTable,
  },
  setup() {
    onMounted(() => {
      getUserList()
    })
    let data = reactive({
      drafrList: [
        { name: '小组排名', text: 'id' },
        { name: '小组名称', text: 'groupName' },
        { name: '股票比率', text: 'shareRatio' },
        { name: '期货比率', text: 'futuresRatio' },
        { name: '债券比率', text: 'bondRatio' },
        { name: '现金比率', text: 'cashRatio' },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: true,
      spreadTable: [],
      tableHeight: 450,
    })
    let getUserList = () => {
      data.loading = true
      let parame = {
        classId: JSON.parse(sessionStorage.getItem('classId')),
        benchmark: 'SZ50',
        page: data.currentPage,
        pageSize: data.pageSize,
      }
      findAssetAllocation(parame).then(res => {
        if (res.data.code === '200') {
          let newRes = res.data.data
          data.spreadTable = newRes.pageObject
          data.spreadTable.forEach(item=>{
            item.futuresRatio = item.futuresRatio || '0'
            item.shareRatio   = item.shareRatio   || '0'
            item.bondRatio    = item.bondRatio    || '0'
            item.cashRatio    = item.cashRatio    || '1'
          })
          data.total = newRes.total
          setTimeout(() => {
            data.loading = false
          }, 300)
        }
      })
    }
    let sizeChange = (val) => {
      data.pageSize = val
      getUserList(data)
    }
    let currentChange = (val) => {
      data.currentPage = val
      getUserList(data)
    }

    return {
      ...toRefs(data),
      sizeChange,
      currentChange,
    }
  }
})
</script>

<style scoped lang="less">
.card-line {
  display: inline-block;
  width: 3px;
  height: 13px;
  border-radius: 8px;
  margin-right: 10px;
  background:  #3B6EFB;
}
</style>